let prefixed = name => 'bookingmanagement/' + name

export const donutCriteria = prefixed('donutCriteria')
export const rainbowCriteria = prefixed('rainbowCriteria')
export const btmSubmitData = prefixed('btmSubmitData')
export const bookingChangeCriteria = prefixed('bookingChangeCriteria')



// WEBPACK FOOTER //
// ./src/components/booking/store/definition.js